import { render, staticRenderFns } from "./public_new.vue?vue&type=template&id=fea6615e&scoped=true&"
import script from "./public_new.vue?vue&type=script&lang=js&"
export * from "./public_new.vue?vue&type=script&lang=js&"
import style0 from "./public_new.vue?vue&type=style&index=0&id=fea6615e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea6615e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTheCookie: require('/web/components/base/TheCookie.vue').default,BaseTheNewHeader: require('/web/components/base/TheNewHeader.vue').default,BaseTheNewFooter: require('/web/components/base/TheNewFooter.vue').default})
